
let oldText = $(".csv-upload .popup-inner > h2 span").text();
let oldText2 = $(".csv-upload .loader-payemnt h2").text();
var fontDictionary = {
    Cinderella: {
        fontFamily: 'Cinderella',
        fontSize: '35px',
        mobileFontSize: '20px'
    },
    Hercules: {
        fontFamily: 'Hercules',
        fontSize: '35px',
        mobileFontSize: '20px'
    },
    Merlin: {
        fontFamily: 'Merlin',
        fontSize: '35px',
        mobileFontSize: '20px'
    },
    Rapunzel: {
        fontFamily: 'Rapunzel',
        fontSize: '35px',
        mobileFontSize: '20px'
    },
    Scar: {
        fontFamily: 'Scar',
        fontSize: '35px',
        mobileFontSize: '20px'
    },
    Stitch: {
        fontFamily: 'astSpahn',
        fontSize: '35px',
        mobileFontSize: '20px'
    },
    Simba: {
        fontFamily: 'astSarah',
        fontSize: '30px',
        mobileFontSize: '23px'
    },
    Roo: {
        fontFamily: 'astRobinl',
        fontSize: '19px',
        mobileFontSize: '10px'
    },
    Nemo: {
        fontFamily: 'astNelson',
        fontSize: '30px',
        mobileFontSize: '22px'
    },
    Lumiere: {
        fontFamily: 'astLukens',
        fontSize: '40px',
        mobileFontSize: '28px'
    },
    Kaa: {
        fontFamily: 'UntitledTTF',
        fontSize: '25px',
        mobileFontSize: '13px'
    },
    Dumbo: {
        fontFamily: 'astDunn',
        fontSize: '30px',
        mobileFontSize: '24px'
    },
    Bolt: {
        fontFamily: 'astBowen',
        fontSize: '40px',
        mobileFontSize: '25px'
    },
    Pinocchio: {
        fontFamily: 'astPea',
        fontSize: '10px',
        mobileFontSize: '8px'
    },
    Tarzan: {
        fontFamily: 'astTracy',
        fontSize: '40px',
        mobileFontSize: '20px'
    },
//     Belle: {
//         fontFamily: 'astBecca',
//         fontSize: '56px',
//         mobileFontSize: '34px'
//     },
    Aladdin: {
        fontFamily: 'Aladdin',
        fontSize: '30px',
        mobileFontSize: '20px'
    },
    Woody: {
        fontFamily: 'Woody',
        fontSize: '30px',
        mobileFontSize: '20px'
    },
    Sarabi: {
        fontFamily: 'Sarabi',
        fontSize: '30px',
        mobileFontSize: '20px'
    },
    Goofy: {
        fontFamily: 'Goofy',
        fontSize: '30px',
        mobileFontSize: '20px'
    },
    Donald: {
        fontFamily: 'Donald',
        fontSize: '30px',
        mobileFontSize: '20px'
    },
  	Boo: {
        fontFamily: 'Boo',
        fontSize: '40px',
        mobileFontSize: '20px'
    },
    Copper: {
        fontFamily: 'Copper',
        fontSize: '40px',
        mobileFontSize: '20px'
    },
    Jasmine: {
        fontFamily: 'Jasmine',
        fontSize: '40px',
        mobileFontSize: '20px'
    },
    Rafiki: {
        fontFamily: 'Rafiki',
        fontSize: '30px',
        mobileFontSize: '20px'
    },
    Ratigan: {
        fontFamily: 'Ratigan',
        fontSize: '40px',
        mobileFontSize: '20px'
    },
    Triton: {
        fontFamily: 'Triton',
        fontSize: '40px',
        mobileFontSize: '20px'
    }
};

function message(heading,success){

$(".csv-upload").fadeIn();
$(".csv-upload .loader-wrapper + h2 span").text(heading);
$(".csv-upload .loader-payemnt h2").text(success);
setTimeout(function(){
$(".csv-upload .loader-wrapper + h2").hide();
$(".csv-upload .loader-payemnt").show().addClass("loader-payemnt-active");
},1500);
setTimeout(function(){
$(".csv-upload").fadeOut();
$(".csv-upload .loader-payemnt").show().removeClass("loader-payemnt-active");
$(".csv-upload .loader-wrapper + h2 span").text(oldText);
$(".csv-upload .loader-payemnt h2").text(oldText2);
},5000);
}
function setVariantUniqueData(fileUrl, itemData, index) {
  var indexAsString = index.toString();
  var variantId = itemData.variant_id + indexAsString;
  var message = itemData.properties.custom_message;
  var font = itemData.properties.font_selection;
  return new Promise(function(resolve, reject) {
  	Papa.parse(fileUrl, {
      download: true,
      header: true,
      complete: function(results) {
     
        var indexesToRemove = [];

        //Remove bad rows from parser?
        for (var b = 0; b < results.errors.length; b++) {
          indexesToRemove.push(results.errors[b].row)
        }

        indexesToRemove.sort(function(a,b){ return b - a; });
        for (var i = indexesToRemove.length - 1; i >= 0; i--) {
        	results.data.splice(indexesToRemove[i], 1);
        }
        var response = {
          results: results,
          variant: variantId,
          message: message,
          font: font
        };
        return resolve(response);
      }
    });
  });
}
let gettingData = localStorage.getItem("cartData")
if (gettingData != null && gettingData != "undefined" && gettingData != "[]") {
  let data = JSON.parse(gettingData),
    grandPrice = 0;

async function processData(product,e,index,totalPrice,reverseIndex) {
      let htmlContent = "<div class=\"payment_cards_grid_item\" data-line=\"" + index + "\" style=\"order:" + reverseIndex + "\">" +
        product;
      // Gift Card
      if (e?.additionalProducts?.giftCard) {
        let id = e.additionalProducts.giftCard.id,
          qyt = e.additionalProducts.giftCard.qyt;

        try {
          const giftCardData = await $.getJSON(`${e.additionalProducts.giftCard.url}.js`);
          const giftCard = giftCardData.variants.find(e => e.id == id);
          if (giftCard) {
            totalPrice = parseFloat(totalPrice) + parseFloat(giftCard.price / 100 * qyt);
            htmlContent += `<div class="payment_cards_grid_item_content payment_cards_grid_item_second_block">
          <div class="payment_cards_grid_item_second_block_left">
            <div class="second_block_left_image">
              <img src="${giftCardData.featured_image}" alt="">
            </div>
            <div class="second_block_left_content">
              <div class="second_block_left_gift">
                <span>Gift Card:</span>
                <p>${giftCardData.title}</p>
              </div>
            </div>
          </div>
          <div class="payment_cards_grid_item_second_block_middel">
            <div class="second_block_middel_price">
              <span>Price:</span>
              <p>${formatter.format(giftCard.price / 100)}</p>
            </div>
            <div class="second_block_middel_quantity">
              <span>Quantity:</span>
              <p>${qyt}</p>
            </div>
            <div class="second_block_middel_subtotal">
              <span>Subtotal:</span>
              <p>${formatter.format(giftCard.price / 100 * qyt)}</p>
            </div>
          </div>
          <div class="payment_cards_grid_item_second_block_right">
            <button class="second_block_right_delete_card" onclick="removeGiftCard(${index})">DELETE CARD</button>
          </div>
        </div>`;
          }
        } catch (error) {
          console.error("Error fetching gift card data", error);
        }
      }
      // Postage US
      if (e?.additionalProducts?.postageUS) {
        let id = e.additionalProducts.postageUS.id,
          qyt = e.additionalProducts.postageUS.qyt;

        try {
          const giftCardData = await $.getJSON(`${e.additionalProducts.postageUS.url}.js`);
          const giftCard = giftCardData.variants.find(e => e.id == id);
          if (giftCard) {
            totalPrice = parseFloat(totalPrice) + parseFloat(giftCard.price / 100 * qyt);
            htmlContent += `<div class="payment_cards_grid_item_content payment_cards_grid_item_third_block">
          <div class="payment_cards_grid_item_third_block_left">
            <div class="third_block_left_image">
              <img src="${giftCardData.featured_image}" alt="">
            </div>
            <div class="third_block_left_content">
              <div class="third_block_left_gift">
                <span>${giftCardData.title} ${giftCard.title}</span>
              </div>
            </div>
          </div>
          <div class="payment_cards_grid_item_third_block_middel">
            <div class="third_block_middel_price">
              <span>Price:</span>
              <p>${formatter.format(giftCard.price / 100)}</p>
            </div>
            <div class="third_block_middel_quantity">
              <span>Quantity:</span>
              <p>${qyt}</p>
            </div>
            <div class="third_block_middel_subtotal">
              <span>Subtotal:</span>
                       <p>${formatter.format(giftCard.price / 100 * qyt)}</p>
            </div>
          </div>
          <div class="payment_cards_grid_item_third_block_right"></div>
        </div>`;
          }
        } catch (error) {
          console.error("Error fetching gift card data", error);
        }
      }
      // Postage Non US
      if (e?.additionalProducts?.postageNonUS) {
        let id = e.additionalProducts.postageNonUS.id,
          qyt = e.additionalProducts.postageNonUS.qyt;

        try {
          const giftCardData = await $.getJSON(`${e.additionalProducts.postageNonUS.url}.js`);
          const giftCard = giftCardData.variants.find(e => e.id == id);
          if (giftCard) {
            totalPrice = parseFloat(totalPrice) + parseFloat(giftCard.price / 100 * qyt);
            htmlContent += `<div class="payment_cards_grid_item_content payment_cards_grid_item_third_block">
          <div class="payment_cards_grid_item_third_block_left">
            <div class="third_block_left_image">
              <img src="${giftCardData.featured_image}" alt="">
            </div>
            <div class="third_block_left_content">
              <div class="third_block_left_gift">
                <span>${giftCardData.title} ${giftCard.title}</span>
              </div>
            </div>
          </div>
          <div class="payment_cards_grid_item_third_block_middel">
            <div class="third_block_middel_price">
              <span>Price:</span>
              <p>${formatter.format(giftCard.price / 100)}</p>
            </div>
            <div class="third_block_middel_quantity">
              <span>Quantity:</span>
              <p>${qyt}</p>
            </div>
            <div class="third_block_middel_subtotal">
              <span>Subtotal:</span>
                       <p>${formatter.format(giftCard.price / 100 * qyt)}</p>
            </div>
          </div>
          <div class="payment_cards_grid_item_third_block_right"></div>
        </div>`;
          }
          
        } catch (error) {
          console.error("Error fetching gift card data", error);
        }
      }
      // Shipping
      if (e?.additionalProducts?.shipping) {
        let id = e.additionalProducts.shipping.id,
          qyt = e.additionalProducts.shipping.qyt;

        try {
          const giftCardData = await $.getJSON(`${e.additionalProducts.shipping.url}.js`);
const varData = await $.getJSON(`/variants/${e.additionalProducts.shipping.id}.js`);
          console.log(giftCardData);
          const giftCard = giftCardData.variants.find(e => e.id == id);
          if (giftCard) {
            totalPrice = parseFloat(totalPrice) + parseFloat(giftCard.price / 100 * qyt);
            htmlContent += `<div class="payment_cards_grid_item_content payment_cards_grid_item_fourth_block">
          <div class="payment_cards_grid_item_fourth_block_left">
            <div class="fourth_block_left_image">
              <img src="${giftCardData.featured_image}" alt="">
            </div>
            <div class="fourth_block_left_content">
              <div class="fourth_block_left_gift">
       <span>${varData.title}</span>
              </div>
            </div>
          </div>
          <div class="payment_cards_grid_item_fourth_block_middel">
            <div class="fourth_block_middel_price">
              <span>Price:</span>
              <p>${formatter.format(giftCard.price / 100)}</p>
            </div>
            <div class="fourth_block_middel_quantity">
              <span>Quantity:</span>
              <p>${qyt}</p>
            </div>
            <div class="fourth_block_middel_subtotal">
              <span>Subtotal:</span>
                <p>${formatter.format(giftCard.price / 100 * qyt)}</p>
            </div>
          </div>
          <div class="payment_cards_grid_item_fourth_block_right"></div>
        </div>`;
          }
        } catch (error) {
          console.error("Error fetching shipping data", error);
        }
      }
      htmlContent +=
        "<div class=\"payment_cards_grid_item_content payment_cards_grid_item_fifth_block\">" +
        "<div class=\"payment_cards_grid_item_fifth_block_left\"></div>" +
        "<div class=\"payment_cards_grid_item_fifth_block_middle\">" +
        "<div class=\"fifth_block_middle_subtotal\" data-price=\""+totalPrice+"\">" +
        "<span>SUBTOTAL</span>" +
        "<p>" + formatter.format(totalPrice) + "</p>" +
        "</div>" +
        "</div>" +
        "<div class=\"payment_cards_grid_item_fifth_block_right\">"+
        "</div>" +
        "</div>" +
        "</div>";
if(!$(".payment_cards_grid_wrapper").hasClass("has-html")){
  $(".payment_cards_grid_wrapper").addClass("has-html");
    $(".payment_card_footer").show();
}
      $(".payment_cards_grid_wrapper").prepend(htmlContent);


 let totat = 0;
$(".fifth_block_middle_subtotal").each(function(){
  totat += $(this).data("price");
})
$(".grand_total_price p,.order_summary_plan p,.order_summary_total p").text( formatter.format(totat) );
$(".grand_total_price p").attr("data-price",totat);
$(".payment_cards_grid_item").each(function(){
if($(this).find(".payment_cards_grid_item_content:nth-child(2)").hasClass("payment_cards_grid_item_second_block")){
$(this).find(".first_block_giftCard").hide()
}
    else{
$(this).find(".first_block_giftCard").show()
    }
    
})
    }
  function cart(data){
  data.forEach(function (e, index) {
 const reverseIndex = data.length - 1 - index;
    let proPrice = e.productPrice.replace("$", "").replace(",", "");
    let giftcard = "",
      postageNonUS = "",
      postageUS = "",
      shipping = "",
      totalPrice = 0;
$.getJSON(`${e.productUrlGet}.js`, function(product) {
     return product;
    }).then(function (pro) {
console.log(pro)
let proPrices = e.productPrice;
if(!proPrices.includes("$")){
  proPrices = formatter.format(e.productPrice);
}
    let product = `<div class="payment_cards_grid_item_content payment_cards_grid_item_first_block"><div class="payment_cards_grid_item_first_block_left">
            <div class="first_block_left_image">
              <img src="${pro.featured_image}" alt="">
            </div>
            <div class="first_block_left_content">
              <h3><a href="${pro.url}">${e.productTitle}</a></h3>
              <div class="first_block_left_sender">
                <span>Sender:</span> 
                <p> ${e.properties.sender_address1}<br>${e.properties.sender_address2}<br>                 
                  ${e.properties.sender_city}, ${e.properties.sender_state} ${e.properties.sender_zip}, ${e.properties.sender_country}
                </p>
              </div>
            <div class="first_block_left_button">
                <button class="" onclick="previewMessage(${index})">PREVIEW YOUR CUSTOM MESSAGE</button>
              </div>
            </div>
          </div>
          <div class="payment_cards_grid_item_first_block_middel">
            <div class="first_block_middel_price">
              <span>Price:</span>
              <p>${proPrices}</p>
            </div>
            <div class="first_block_middel_quantity">
              <span>Quantity:</span>
              <p>${e.qyt}</p>
            </div>
            <div class="first_block_middel_subtotal">
              <span>Subtotal:</span>
              <p>${formatter.format(proPrice * e.qyt)}</p>
            </div>
          </div>
          <div class="payment_cards_grid_item_first_block_right">
<button class="first_block_giftCard" onclick="giftCard(${index})" style="display:none;">ADD GIFT CARD</button>            
<a class="first_block_right_edit_order" href="${pro.url}?editproduct=${index}">EDIT ORDER</a>
            <button class="first_block_right_delete_order" onclick="removeProduct(${index})">DELETE ORDER</button>
          </div>
        </div>`;
    totalPrice = proPrice * e.qyt;
 
processData(product,e,index,totalPrice,reverseIndex);

            });

   
  })

  }
cart(data);


// Remove Gift Card
 function removeGiftCard(index){
const indexs = index;
$(".gift-card-delete").fadeIn();
$(".gift-card-delete .stop-subscribe").attr("data-index",indexs);
}


// Remove Product  
  function removeProduct(index){
const indexs = index;
$(".order-card-delete").fadeIn();
$(".order-card-delete .stop-subscribe").attr("data-index",indexs);
  }

// ADD GIFT CARD

function giftCard(index){
$(".giftCardPopUp").fadeIn();
$(".addGiftCard").click(function(){
let gettingCartData = localStorage.getItem("cartData")
if (gettingCartData != null && gettingCartData != "undefined" && gettingCartData != "[]") {
$(".giftCardPopUp").fadeOut();
$(".csv-upload").fadeIn();
$(".csv-upload .loader-wrapper + h2 span").text("Adding gift card");
$(".csv-upload .loader-payemnt h2").text("Gift card added successfully");
  let data = JSON.parse(gettingCartData);
let giftName = $("#gift_name").val(),
  giftid = $("#gift_price").val(),
  giftUrl = $("#gift_name option:selected").data('url');
let  giftCard = {
    "id": giftid,
    "url": giftUrl,
    "qyt": data[index].qyt
  };
data[index].properties.gift_id = giftid;
  data[index].additionalProducts.giftCard = giftCard;
localStorage.setItem("cartData", JSON.stringify(data));    

setTimeout(function(){
$(".csv-upload .loader-wrapper + h2").hide();
$(".csv-upload .loader-payemnt").show().addClass("loader-payemnt-active");
$(".payment_cards_grid_wrapper").html(" ");
$(".payment_cards_grid_wrapper").removeClass("has-html");

},1000);
setTimeout(function(){

$(".csv-upload").fadeOut();
$(".csv-upload .loader-payemnt").show().removeClass("loader-payemnt-active");
$(".csv-upload .loader-wrapper + h2 span").text(oldText);
$(".csv-upload .loader-payemnt h2").text(oldText2);
 location.reload();
},4000);

}
});
}
  
// PREVIEW YOUR CUSTOM MESSAGE
function previewMessage(index){
let gettingCartData = localStorage.getItem("cartData");
  let data = JSON.parse(gettingCartData);
if(data[index]?.properties.custom_font){
var font_name = data[index]?.properties?.custom_font.replace(/\.[^/.]+$/, "");
var cssCode = `
@font-face {
font-family: '`+font_name+`';
src: url(https://api.simplynoted.com/fonts/myFont/`+data[index]?.properties.custom_font+`);
}`;
$('head').append('<style>' + cssCode + '</style>');
} 

  if(data[index]?.properties.selectedText == "Single Card"){
    $('.cards_grid_item_preview-wrapper-all').slick('unslick');
let recipient_address = data[index]?.properties.recipient_fullName + ", ";
if(data[index]?.properties.recipient_address1){
  recipient_address += data[index]?.properties.recipient_address1 + ", ";
}
if(data[index]?.properties.recipient_address2){
  recipient_address += data[index]?.properties.recipient_address2 + ", ";
}
if(data[index]?.properties.recipient_city){
  recipient_address += data[index]?.properties.recipient_city + ", ";
}
if(data[index]?.properties.recipient_state){
  recipient_address += data[index]?.properties.recipient_state + ", ";
}
if(data[index]?.properties.recipient_zip){
  recipient_address += data[index]?.properties.recipient_zip + ", ";
}
if(data[index]?.properties.recipient_country){
  recipient_address += data[index]?.properties.recipient_country ;
}

let customMessage = data[index]?.properties.custom_message.replaceAll("\n","<br>").replaceAll('"','');
let jsonCSV = `<div class="cards_grid_item_preview-wrapper">
      <div class="cards_grid_item_preview_header">
        <div class="item_preview_header_info">
          <div>
            <span>Recipient:</span>
            <p>${recipient_address.replaceAll('"','')}</p>
          </div>
        </div>
        <h3 class="cards_grid_item_preview_heading">Your Custom Message:</h3>
      </div>
      <div class="cards_grid_item_preview_content" style="font-family:${data[index]?.properties.font_family};font-size:${data[index]?.properties.font_size_cust_card};line-height:${data[index]?.properties.line_ht_cust_card}">
      ${customMessage} <span class="signoff">${data[index]?.properties.signoff}</span>
      </div>
      <div class="item_preview_header_info">
        <div>
          <span>Font:</span>
          <p>${data[index]?.properties.font_selection}</p>
        </div>
      </div>
</div>`;
$(".cards_grid_item_preview-wrapper-all").html(jsonCSV);
$(".payment_cards_grid_item_preview").addClass("active");
$(".payment_cards_grid_item_preview").fadeIn();
$(".popup-inner").addClass("open_popup_inner");
$('.cards_grid_item_preview-wrapper-all').slick({
  infinite: false,
  slidesToShow: 1,
  slidesToScroll: 1
});

  }
  else{

$(".csv-upload .loader-wrapper + h2 span").text("Loading data, please wait");
$(".csv-upload").fadeIn();
$('.cards_grid_item_preview-wrapper-all').slick('unslick');
let allData = "";
$.get(data[index]?.properties.recipient_upload, function (csvData) {
 const jsonData = [];
  Papa.parse(csvData, {
      header: true,
      dynamicTyping: true,
      complete: function (results) {
        jsonData.push(results.data);
        // Process the parsed data here
      },
      error: function (error) {
        console.log(error.message);
      }
    });

                // // Split CSV data into rows
                // const rows = csvData.split('\n');

                // // Get the headers (first row) and split it into an array
                // const headers = rows[0].split(',');

               
                // for (let i = 1; i < rows.length; i++) {                     
                //     const data = rows[i].split(',');
                //     const entry = {};
              
                //     // Loop through each header and map it to the corresponding data
                //     for (let j = 0; j < headers.length; j++) {
                //         // Remove spaces from the key and convert to lowercase
                //         const key = headers[j].replace(/"/g, '').trim().toLowerCase().replaceAll(/ /g, '_');
                //         entry[key] = data[j];
                //     }
                //     jsonData.push(entry);
                // }
console.log(jsonData);
jsonData[0].forEach(function(e){ 
  if(e.Type != null ||e["First Name"] != null ){
let recipient_address ="";
if(e["First Name"]){
  recipient_address +=  e["First Name"] + " ";
}
if(e["Last Name"]){
  recipient_address +=  e["Last Name"];
}
if(e["Address"]){
  recipient_address +=   ", " + e["Address"] + ", ";
}
if(e["Address 2"]){
  recipient_address += e["Address 2"] + ", ";
}
if(e["City"]){
  recipient_address += e["City"] + ", ";
}
if(e["State/Province"]){
  recipient_address += e["State/Province"] + ", ";
}
if(e["Postal Code"]){
  recipient_address += e["Postal Code"] + ", ";
}
if(e["Country"]){
  recipient_address += e["Country"] + ", ";
}

      

let customMessage = data[index]?.properties.custom_message;
console.log(e["First Name"],e["Custom 3"],e);
if(e["First Name"] != '' && e["First Name"] != null){
  customMessage = customMessage.replaceAll('[First Name]',e["First Name"]);
}
      else{
      customMessage = customMessage.replaceAll('[First Name]', " ");
  }
if(e["Last Name"] != '' && e["Last Name"] != null){
  customMessage = customMessage.replaceAll('[Last Name]',e["Last Name"])
}
      else{
      customMessage = customMessage.replaceAll('[Last Name]', " ");
  }
if(e["Company"] != '' && e["Company"] != null){
  customMessage = customMessage.replaceAll('[Company]',e["Company"])
}
      else{
      customMessage = customMessage.replaceAll('[Company]', " ");
  }
if(e["Custom 1"] != '' && e["Custom 1"] != null){
  customMessage = customMessage.replaceAll('[Custom 1]',e["Custom 1"])
}
    else{
      customMessage = customMessage.replaceAll('[Custom 1]', " ");
  }
if(e["Custom 2"] != '' && e["Custom 2"] != null){
  customMessage = customMessage.replaceAll('[Custom 2]',e["Custom 2"])
}
    else{
      customMessage = customMessage.replaceAll('[Custom 2]', " ");
  }
if(e["Custom 3"] != '' && e["Custom 3"] != null){
  customMessage = customMessage.replaceAll('[Custom 3]',e["Custom 3"])
}
  else{
      customMessage = customMessage.replaceAll('[Custom 3]', "");
  }

customMessage = customMessage.replaceAll("\n","<br>").replaceAll('"','');
                    
                    
                    
                    
                    

let jsonCSV = `<div class="cards_grid_item_preview-wrapper">

      <div class="cards_grid_item_preview_header">
        <div class="item_preview_header_info">
          <div>
            <span>Recipient:</span>
            <p>${recipient_address.replaceAll('"','')}</p>
          </div>
        </div>
        <h3 class="cards_grid_item_preview_heading">Your Custom Message:</h3>
      </div>
      <div class="cards_grid_item_preview_content" style="font-family:${data[index]?.properties.font_family};font-size:${data[index]?.properties.font_size_cust_card};line-height:${data[index]?.properties.line_ht_cust_card}">
      ${customMessage} <span class="signoff">${data[index]?.properties.signoff}</span>
      </div>
      <div class="item_preview_header_info">
        <div>
          <span>Font:</span>
          <p>${data[index]?.properties.font_selection}</p>
        </div>
      </div>
</div>`;
allData += jsonCSV;
  }
})
   
            }).then(function () {
$(".cards_grid_item_preview-wrapper-all").html(allData);
  setTimeout(function(){
$(".csv-upload").fadeOut();
$(".payment_cards_grid_item_preview").addClass("active");
$(".payment_cards_grid_item_preview").fadeIn();
$(".popup-inner").addClass("open_popup_inner");
$('.cards_grid_item_preview-wrapper-all').slick({
  infinite: false,
  slidesToShow: 1,
  slidesToScroll: 1
});
    },1500)
  setTimeout(function(){
$(".csv-upload .loader-wrapper + h2 span").text(oldText);
$(".csv-upload .loader-payemnt h2").text(oldText2);
  },2200);
            });
}


}

// Remove Delete
$(".gift-card-delete .stop-subscribe").click(function(){
$(".gift-card-delete,.loader-payemnt").hide();
$(".csv-upload h2").show();
message("Deleting gift card","Gift card is successfully deleted.");
const indexToRemoveFrom = $(this).attr("data-index");
setTimeout(function(){
$(".payment_cards_grid_wrapper").html(" ");
$(".payment_cards_grid_wrapper").removeClass("has-html")
let gettingData = localStorage.getItem("cartData")
if (gettingData != null && gettingData != "undefined") {
let data = JSON.parse(gettingData);

if (data[indexToRemoveFrom]?.additionalProducts) {
data[indexToRemoveFrom].additionalProducts.giftCard = null;
}
  data[indexToRemoveFrom].properties.gift_id = null;
localStorage.setItem("cartData", JSON.stringify(data));
}
let gettingDataAgain = localStorage.getItem("cartData");
if(gettingDataAgain != "[]" && gettingDataAgain != [] &&  gettingDataAgain != null && gettingDataAgain != "undefined"){
let featching = JSON.parse(gettingDataAgain);
cart(featching);
}
},2500);
   
});
// Delete Order
$(".order-card-delete .stop-subscribe").click(function(){
$(".order-card-delete,.loader-payemnt").hide();
$(".csv-upload h2").show();
message("Deleting order","Order deleted successfully");
const indexToRemove = $(this).attr("data-index");
setTimeout(function(){
$(`.payment_cards_grid_item[data-line="${indexToRemove}"]`).fadeOut();
$(".payment_cards_grid_wrapper").html(" ");
$(".payment_cards_grid_wrapper").removeClass("has-html");
let gettingData = localStorage.getItem("cartData")
if (gettingData != null && gettingData != "undefined") {
let datagsdg = JSON.parse(gettingData);
datagsdg.splice(indexToRemove, 1);
console.log(datagsdg)
localStorage.setItem("cartData", JSON.stringify(datagsdg));
let gettingDataAgain = localStorage.getItem("cartData");
console.log(gettingDataAgain)
if(gettingDataAgain != "[]" && gettingDataAgain != [] &&  gettingDataAgain != null && gettingDataAgain != "undefined"){
let featching = JSON.parse(gettingDataAgain);
setTimeout(function(){
  location.reload();
},500)
$(".payment_cards_grid_wrapper").removeClass("empty");
}
  else{
    if(!$(".payment_cards_grid_wrapper").hasClass("has-html")){
  $(".payment_cards_grid_wrapper").addClass("has-html");
} 
    $(".payment_card_header,.payment_card_footer").hide();
$(".payment_cards_grid_wrapper").addClass("empty");
$(".payment_cards_grid_wrapper").html(`
<div class="cart-empty">Your Cart Is empty!
<div><a href="/collections/best-sellers">Continue Shopping</a></div>
</div>
`);
   
  }
}
let gettingDatad = localStorage.getItem("cartData")
if (gettingDatad != null && gettingDatad != "undefined") {
let data = JSON.parse(gettingDatad);
  let cartCount = 0;
    data.forEach(function(e){
     cartCount += e.qyt
})
   if(cartCount > 99){
                      $(".tt-dropdown-toggle").addClass('f3')
                  }
                  if(cartCount > 999){
                      $(".tt-dropdown-toggle").addClass('f4')
                  }
                  if(cartCount > 9999){
                      $(".tt-dropdown-toggle").addClass('f5')
                  }
                  if(cartCount > 99999){
                      $(".tt-dropdown-toggle").addClass('f6')
                  }
                  if(cartCount > 999999){
                      $(".tt-dropdown-toggle").addClass('f7')
                  }
$(".tt-badge-cart").text(cartCount);
}
},2500);
});

function clearCart(){
    localStorage.setItem("cartData","[]");
    $(".payment_card_header,.payment_card_footer").hide();
$(".payment_cards_grid_wrapper").addClass("empty");
$(".payment_cards_grid_wrapper").html(`
<div class="cart-empty">Your Cart Is empty!
<div><a href="/collections/best-sellers">Continue Shopping</a></div>
</div>
`);
  $(".tt-badge-cart").text("0")
 window.scrollTo({top: 0, behavior: 'smooth'});
  }

} else {
  if(!$(".payment_cards_grid_wrapper").hasClass("has-html")){
  $(".payment_cards_grid_wrapper").addClass("has-html");
} 
$(".payment_cards_grid_wrapper").addClass("empty");
$(".payment_card_header,.payment_card_footer").hide();
$(".payment_cards_grid_wrapper").html(`
<div class="cart-empty">Your Cart Is empty!
<div><a href="/collections/best-sellers">Continue Shopping</a></div>
</div>
`);
}

  $(".close-btn").click(function () {
$(".popup-body").fadeOut();
      $(this).parents(".popup-section").delay(300).fadeOut();
  });
$('.cards_grid_item_preview-wrapper-all').slick({
  infinite: false,
  slidesToShow: 1,
  slidesToScroll: 1
});